// Single source of truth for valid magnet flow step_type values. Previously
// magnets.js's STEP_TYPES and magnet-flow.js's TYPE_META/TYPE_ORDER were two
// independently-maintained lists that happened to match — the same drift shape as
// magnetPublic.js's KNOWN_FIELDS vs. magnet-flow.js's FIELD_SUGGESTIONS (now
// LEAD_CAPTURE_FIELDS) and the support_topics defaults, both of which actually
// drifted this session. Closing this one off before it becomes a third instance.
export const STEP_TYPES = [
  { value: 'single_select', label: 'Multiple choice' },
  { value: 'multi_select', label: 'Select all' },
  { value: 'scheduler', label: 'Scheduler' },
  { value: 'text', label: 'Short text' },
  { value: 'email', label: 'Email' },
  { value: 'phone', label: 'Phone' },
  { value: 'message', label: 'Message' },
];

export const STEP_TYPE_VALUES = new Set(STEP_TYPES.map((t) => t.value));
